/* tslint:disable */
/* eslint-disable */
export enum EventAttributes {
  None = 'None',
  SpecialName = 'SpecialName',
  RtSpecialName = 'RTSpecialName'
}
